import React,{useState} from "react"
import {Modal,ModalHeader,ModalBody,ModalFooter} from "reactstrap"
import ImageEditor,{VIDEO} from "./ImageEditor";
import { useGlobal } from "./Reducer";
import Api from "./Api";
const VIDEO_TYPE_EMBED="EMBED"
const VIDEO_TYPE_FILE="FILE"
const VIDEO_TYPE_LINK="LINK"



import _ from "lodash"

const video_types=[VIDEO_TYPE_EMBED,VIDEO_TYPE_FILE,VIDEO_TYPE_LINK]

export {VIDEO_TYPE_EMBED,VIDEO_TYPE_FILE,VIDEO_TYPE_LINK};




export default (props)=>{

    const [gs,ga]=useGlobal();
    const [showChooser,setShowChooser]=useState(false);
    const [video,setVideo]=useState(gs.appData.video_file);
   
    const [title,setTitle]=useState(gs.appData.video_title||"")
    const [desc,setDesc]=useState(gs.appData.video_description||"")
    const [videoType,setVideoType]=useState(gs.appData.video_type||VIDEO_TYPE_LINK);
    

 
    const removeVideo=()=>{
        Api.removeVideo(gs.appData.id).then(()=>{
            gs.appData.video_file=null;
            setVideo(null);
        });
    }


    const save=()=>{
        if(title.trim().length==0)
        {
            ga.alert("Title required","Title is required");
            return;
        }
        if(desc.trim().length==0)
        {
            ga.alert("Title required","Title is required");
            return;
        }
        ga.loading(true);
        Api.saveVideoData(
            videoType,
            video,title,desc,gs.appData.id).then(()=>{
            gs.appData.video_title=title;
            gs.appData.video_file=video;
            gs.appData.video_description=desc;
            props.onClose();
        }).catch(err=>{}).finally(()=>{
            ga.loading(false);
        });


    }
    

    return (<Modal size={"lg"} isOpen={true}>
               {showChooser && <ImageEditor onClose={()=>setShowChooser(false)}
                    withImage={(image)=>setVideo(image)}
            type={VIDEO}/>}


        <ModalHeader>Video Section</ModalHeader>
        <ModalBody>
                <div>
                <div className="form-group">
                            <label>Title</label>
                            <input type="text" value={title} onChange={e=>{
                                setTitle(e.target.value)
                            }} className="form-control"></input>
                    </div>
                    <div className="form-group">
                            <label>Description</label>
                           
                            <textarea  
                                onChange={e=>{
                                    setDesc(e.target.value);
                                }}
                            className="form-control">{desc}</textarea>
                    </div>


                    <div className="form-group">
                            <label>Video Type</label>
                            <select className="form-control" value={videoType} onChange={e=>{
                                setVideoType(e.target.value)
                                setVideo("");
                            }}>
                                    {_.map(video_types,(vt)=>{
                                        return (<option value={vt} key={vt}>{vt}</option>)
                                    })}
                            </select>    
                        
                    </div>

                             {videoType==VIDEO_TYPE_FILE && <React.Fragment>
                    <div style={{height:200}}>
                        Video File <br/>
                    
                        <video src={video?video:""} controls={true} style={{maxHeight:200,maxWidth:200}}/>
                        <br/>

                                            </div>
                    <div>
                        <button onClick={()=>setShowChooser(true)} className="btn btn-info">Select</button>
                        <button onClick={()=>removeVideo()} className="btn btn-danger">remove</button>
                    </div>
                    </React.Fragment>    }     


                   {videoType!=VIDEO_TYPE_FILE && <div className="form-group">
                             <label>{videoType}</label>  
                             <textarea className="form-control" value={video} onChange={e=>{
                                    setVideo(e.target.value);
                             }} >
                                 </textarea> 
                    </div>  }
                    

                </div>


        </ModalBody>
        <ModalFooter>
        <button onClick={()=>save()} className="btn btn-primary">save</button>
            <button onClick={()=>props.onClose()} className="btn btn-secondary">close</button>
        </ModalFooter>
    </Modal>);
}